import { updateOnboardingScheduleApi as generatedUpdateOnboardingScheduleApi } from '../generated/onboarding/updateOnboardingSchedule';

import { getOnboardProfileDraftApi } from './getOnboardProfileDraft';

const updateOnboardingScheduleApi = generatedUpdateOnboardingScheduleApi.enhanceEndpoints({
  endpoints: {
    updateOnboardingSchedule: {
      invalidatesTags: ['Onboard'],
      onQueryStarted: async ({ body }, { dispatch, queryFulfilled }) => {
        const patchResult = dispatch(
          getOnboardProfileDraftApi.util.updateQueryData('getOnboardProfileDraft', undefined, (draft) => {
            draft.schedule = body.workingSchedule ?? body;

            if (draft.progress != null) {
              draft.progress.schedule = true;
            } else {
              draft.progress = { schedule: true };
            }
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    },
  },
});

export const { useUpdateOnboardingScheduleMutation } = updateOnboardingScheduleApi;
